
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

const DiscographyPage = () => {
  const releases = [
    {
      id: 1,
      title: "あの雲のむこうがわ、その先に",
      type: "Single",
      year: "2025",
      image: "https://readdy.ai/api/search-image?query=Acoustic%20ballad%20album%20cover%20with%20soft%20clouds%20in%20pastel%20sky%2C%20gentle%20sunlight%20breaking%20through%20clouds%2C%20dreamy%20ethereal%20atmosphere%2C%20minimalist%20design%20with%20warm%20golden%20and%20soft%20blue%20tones%2C%20peaceful%20and%20contemplative%20mood%2C%20cinematic%20movie%20soundtrack%20aesthetic&width=300&height=300&seq=acoustic-ballad-cover-v2&orientation=squarish",
      description: "映画「キリコのタクト」の挿入歌オーディオーションのために急遽制作されたアコースティック・バラード。",
      credits: {
        lyrics: "久下暁雅、瀬田一流",
        music: "瀬田一流",
        arrangement: "瀬田一流",
        producer: "瀬田一流"
      },
      genre: "アコースティック・バラード",
      releaseDate: "近日公開"
    },
    {
      id: 2,
      title: "ナイト・フライト",
      type: "Single",
      year: "2025",
      image: "https://readdy.ai/api/search-image?query=Close-up%20portrait%20of%20male%20guitarist%20embracing%20electric%20guitar%20against%20black%20background%2C%20dramatic%20backlighting%20creating%20silhouette%20effect%20around%20figure%20and%20guitar%20outline%2C%20psychedelic%201970s%20aesthetic%20inspired%20by%20Jeff%20Beck%20Blow%20by%20Blow%20album%2C%20moody%20atmospheric%20lighting%2C%20upper%20body%20and%20guitar%20only%20visible%20no%20legs%2C%20intimate%20embrace%20pose%20with%20instrument%2C%20vintage%20rock%20album%20cover%20style&width=300&height=300&seq=night-flight-cover-v4&orientation=squarish",
      description: "久下暁雅の新境地を示すガレージロック楽曲。",
      credits: {
        lyrics: "久下暁雅",
        music: "久下暁雅",
        arrangement: "瀬田一流",
        producer: "瀬田一流"
      },
      genre: "ガレージロック",
      releaseDate: "近日公開"
    }
  ];

  const albums = [
    {
      id: 1,
      title: 'あの雲のむこうがわ、その先に',
      type: 'Single',
      year: '2025',
      image: 'https://readdy.ai/api/search-image?query=Cinematic%20acoustic%20ballad%20album%20cover%20design%2C%20movie%20soundtrack%20aesthetic%2C%20emotional%20and%20dramatic%20atmosphere%2C%20soft%20lighting%20with%20clouds%20and%20sky%2C%20artistic%20typography%2C%20professional%20music%20album%20artwork%2C%20warm%20colors%2C%20simple%20clean%20background%2C%20intimate%20feeling&width=400&height=400&seq=acoustic-ballad-disco&orientation=squarish',
      tracks: ['あの雲のむこうがわ、その先に', 'あの雲のむこうがわ、その先に (Instrumental)']
    },
    {
      id: 2,
      title: 'ナイト・フライト',
      type: 'Single',
      year: '2025',
      image: 'https://readdy.ai/api/search-image?query=Psychedelic%20album%20cover%20design%20inspired%20by%20Jeff%20Beck%20Blow%20by%20Blow%20style%2C%20male%20guitarist%20silhouette%20swaying%20and%20moving%20in%20dreamy%20motion%20blur%2C%20vibrant%20colors%20and%20surreal%20atmosphere%2C%20electric%20guitar%20elements%2C%20retro%2070s%20aesthetic%2C%20artistic%20distortion%20effects%2C%20professional%20music%20album%20artwork%2C%20simple%20clean%20background%20with%20psychedelic%20patterns&width=400&height=400&seq=psychedelic-guitar-disco&orientation=squarish',
      tracks: ['ナイト・フライト', 'ナイト・フライト (Instrumental)']
    },
    {
      id: 3,
      title: '心の旋律',
      type: 'Album',
      year: '2023',
      image: 'https://readdy.ai/api/search-image?query=Album%20cover%20design%20for%20heart%20melody%20theme%2C%20warm%20colors%2C%20artistic%20typography%2C%20professional%20music%20album%20artwork%2C%20emotional%20and%20intimate%20feeling%2C%20simple%20clean%20background&width=400&height=400&seq=album-1&orientation=squarish',
      tracks: ['心の旋律', '風のうた', '夜明けの空', '君への手紙', '静寂の中で', '希望の光', '旅立ちの日', '永遠の約束', '雨上がり', '心の声']
    },
    {
      id: 4,
      title: '静寂の中で',
      type: 'Album',
      year: '2020',
      image: 'https://readdy.ai/api/search-image?query=Album%20cover%20design%20for%20silence%20theme%2C%20minimalist%20design%2C%20soft%20colors%2C%20artistic%20typography%2C%20professional%20music%20album%20artwork%2C%20peaceful%20atmosphere%2C%20simple%20clean%20background&width=400&height=400&seq=album-3&orientation=squarish',
      tracks: ['静寂の中で', '一人の夜', '記憶の扉', '時の流れ', '心の奥で', '遠い日々', '新しい朝', '希望の歌']
    },
    {
      id: 5,
      title: '青春の日々',
      type: 'Album',
      year: '2019',
      image: 'https://readdy.ai/api/search-image?query=Album%20cover%20design%20for%20youth%20theme%2C%20bright%20colors%2C%20energetic%20feeling%2C%20artistic%20typography%2C%20professional%20music%20album%20artwork%2C%20nostalgic%20atmosphere%2C%20simple%20clean%20background&width=400&height=400&seq=album-4&orientation=squarish',
      tracks: ['青春の日々', '友達', '学校の帰り道', '初恋', '夏の思い出', '卒業式', '新しい扉', '未来への道']
    },
    {
      id: 6,
      title: '始まりの歌',
      type: 'Single',
      year: '2018',
      image: 'https://readdy.ai/api/search-image?query=Album%20cover%20design%20for%20beginning%20theme%2C%20sunrise%20colors%2C%20hopeful%20feeling%2C%20artistic%20typography%2C%20professional%20music%20album%20artwork%2C%20fresh%20start%20atmosphere%2C%20simple%20clean%20background&width=400&height=400&seq=album-5&orientation=squarish',
      tracks: ['始まりの歌', '始まりの歌 (Acoustic Ver.)']
    }
  ];

  const latestSingles = [
    {
      id: 1,
      title: 'あの雲のむこうがわ、その先に',
      subtitle: '久下暁雅デビューシングル　第１弾',
      releaseDate: '近日公開',
      genre: 'アコースティック・バラード',
      credits: {
        lyrics: '久下暁雅、瀬田一流',
        music: '瀬田一流',
        arrangement: '瀬田一流',
        producer: '瀬田一流'
      },
      image: 'https://readdy.ai/api/search-image?query=Acoustic%20singer-songwriter%20holding%20guitar%20in%20intimate%20studio%20setting%2C%20warm%20golden%20lighting%2C%20emotional%20expression%2C%20simple%20clean%20background%2C%20professional%20music%20photography%20style%2C%20soft%20and%20gentle%20atmosphere%2C%20close-up%20portrait%20composition&width=300&height=300&seq=single1-cover&orientation=squarish',
      description: '映画「キリコのタクト」の挿入歌オーディションのために急遽制作された楽曲。'
    },
    {
      id: 2,
      title: 'ナイト・フライト',
      subtitle: '新境地への挑戦',
      releaseDate: '近日公開',
      genre: 'ガレージロック',
      credits: {
        lyrics: '久下暁雅',
        music: '久下暁雅',
        arrangement: '瀬田一流',
        producer: '瀬田一流'
      },
      image: 'https://readdy.ai/api/search-image?query=Male%20guitarist%20embracing%20electric%20guitar%20in%20close-up%20composition%2C%20dark%20black%20background%2C%20dramatic%20backlighting%20creating%20silhouette%20effect%20around%20figure%20and%20guitar%2C%20psychedelic%2070s%20style%2C%20motion%20blur%20effect%2C%20artistic%20composition%20from%20guitar%20to%20upper%20body%20only%2C%20no%20feet%20visible%2C%20moody%20atmospheric%20lighting&width=300&height=300&seq=single2-cover-v2&orientation=squarish',
      description: '久下暁雅の新たな音楽的挑戦を示すガレージロック楽曲。'
    }
  ];

  return (
    <div className="min-h-screen">
      <Header />
      <main className="pt-16">
        {/* Hero Section */}
        <section 
          className="relative py-32 bg-cover bg-center bg-no-repeat"
          style={{
            backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url('https://readdy.ai/api/search-image?query=Music%20studio%20with%20vinyl%20records%20and%20album%20covers%2C%20warm%20lighting%2C%20professional%20recording%20environment%2C%20artistic%20composition%2C%20simple%20clean%20background&width=1920&height=800&seq=disco-hero&orientation=landscape')`
          }}
        >
          <div className="container mx-auto px-6 text-center text-white">
            <h1 className="text-5xl md:text-6xl font-bold mb-6">Discography</h1>
            <p className="text-xl md:text-2xl text-gray-200 max-w-2xl mx-auto">
              これまでにリリースした楽曲たち
            </p>
          </div>
        </section>

        {/* Discography Grid */}
        <section className="py-20 bg-white">
          <div className="container mx-auto px-6">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto">
              {albums.map((album) => (
                <div key={album.id} className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300 group">
                  <div className="relative overflow-hidden">
                    <img
                      src={album.image}
                      alt={album.title}
                      className="w-full aspect-square object-cover object-top transition-transform duration-300 group-hover:scale-105"
                    />
                    <div className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
                      <button className="bg-white text-black px-6 py-3 rounded-full font-medium hover:bg-gray-100 transition-colors cursor-pointer whitespace-nowrap">
                        <i className="ri-play-fill mr-2"></i>
                        再生
                      </button>
                    </div>
                    <div className="absolute top-4 left-4">
                      <span className="bg-black text-white px-3 py-1 rounded-full text-xs font-medium">
                        {album.type}
                      </span>
                    </div>
                  </div>
                  
                  <div className="p-6">
                    <div className="flex items-center justify-between mb-2">
                      <h3 className="text-xl font-bold">{album.title}</h3>
                      <span className="text-gray-500 text-sm">{album.year}</span>
                    </div>
                    
                    <div className="space-y-2">
                      <h4 className="font-semibold text-gray-700 text-sm mb-3">収録曲</h4>
                      <div className="space-y-1">
                        {album.tracks.slice(0, 3).map((track, index) => (
                          <div key={index} className="flex items-center text-sm text-gray-600">
                            <span className="w-6 text-xs">{index + 1}.</span>
                            <span>{track}</span>
                          </div>
                        ))}
                        {album.tracks.length > 3 && (
                          <div className="text-sm text-gray-500 pl-6">
                            他{album.tracks.length - 3}曲
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="mt-6 flex space-x-2">
                      <button className="flex-1 bg-black text-white py-2 px-4 rounded-lg hover:bg-gray-800 transition-colors text-sm font-medium cursor-pointer whitespace-nowrap">
                        <i className="ri-headphone-line mr-2"></i>
                        聴く
                      </button>
                      <button className="flex-1 border border-gray-300 text-gray-700 py-2 px-4 rounded-lg hover:bg-gray-50 transition-colors text-sm font-medium cursor-pointer whitespace-nowrap">
                        <i className="ri-information-line mr-2"></i>
                        詳細
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Streaming Platforms */}
        <section className="py-20 bg-gray-50">
          <div className="container mx-auto px-6 text-center">
            <h2 className="text-4xl font-bold mb-8">配信プラットフォーム</h2>
            <p className="text-xl text-gray-600 mb-12 max-w-2xl mx-auto">
              各種音楽配信サービスでお楽しみいただけます
            </p>
            
            <div className="grid grid-cols-2 md:grid-cols-4 gap-8 max-w-4xl mx-auto">
              <a href="#" className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-shadow duration-300 group cursor-pointer">
                <i className="ri-spotify-fill text-green-500 text-4xl mb-4 group-hover:scale-110 transition-transform"></i>
                <h3 className="font-semibold">Spotify</h3>
              </a>
              <a href="#" className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-shadow duration-300 group cursor-pointer">
                <i className="ri-apple-fill text-gray-700 text-4xl mb-4 group-hover:scale-110 transition-transform"></i>
                <h3 className="font-semibold">Apple Music</h3>
              </a>
              <a href="#" className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-shadow duration-300 group cursor-pointer">
                <i className="ri-youtube-fill text-red-500 text-4xl mb-4 group-hover:scale-110 transition-transform"></i>
                <h3 className="font-semibold">YouTube Music</h3>
              </a>
              <a href="#" className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-shadow duration-300 group cursor-pointer">
                <i className="ri-amazon-fill text-orange-500 text-4xl mb-4 group-hover:scale-110 transition-transform"></i>
                <h3 className="font-semibold">Amazon Music</h3>
              </a>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default DiscographyPage;
